var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.campaign.tasks),function(task){return _c('campaign-task',{key:task.id,attrs:{"task":task}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }